/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = css`
    height: min-content;
    display: grid;
    grid-template:
        'icon . title' auto
        '. . content' auto
        / min-content var(--layout-spacing-12) auto;
    gap: var(--layout-spacing-4) 0;

    .product-details-list-item-icon {
        grid-area: icon;
    }

    .product-details-list-item-title {
        ${theme.typography.body_normal}
        grid-area: title;
    }

    .product-details-list-item-content {
        grid-area: content;
    }

    strong {
        ${theme.typography.body_normal_highlight}
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const styles = () => css`
    ${baseStyles}
`;
